
const state = {
  carInfo: {
    workshop_id: '', // 车间名称（通道）
    plate: '粤', // 当前省份
    brand_id: '', // 车辆品牌ID
    brand: '', // 车辆品牌名称
    visit_time: '', // 进店时间
    visit_workshop_time: '', // 进车间时间
    workshop_plate_number: '', // 进店车辆车牌号 ---- 登记类型为进车间
    plate_number: '' // 当前车牌号的关键字
  }
}

const mutations = {
  'UPDATE_CAR_REGISTER_INFO'(state, carInfo) {
    state.carInfo = carInfo
  }
}

const actions = {
  UPDATE_CAR_REGISTER_INFO({ commit }, carInfo) {
    commit('UPDATE_CAR_REGISTER_INFO', carInfo)
  }
}
export default {
  state,
  actions,
  mutations
}
